import {SwitchProps} from '../components/switch';

export const getSwitch =
  <T>(data: Omit<SwitchProps<T>, 'type'>) =>
  (): SwitchProps<T> => ({
    ...data,
    type: 'switch',
  });
